import React from "react";
import { Box } from "@chakra-ui/react";
import { getSafeCustomer } from "utils";
import { type Customer } from "lib/sanity";
import { sectionSpacingY } from "components/section";
import { AuraPlate, SolidPlate } from "ui/plates";
import { CenteredQuote } from "components/quotes";
import { FeatureAccordion } from "./feature-accordion";
import { SetUpSlideshow } from "./set-up-slideshow";
import { UseCaseGrid } from "./use-case-grid";
import { Faq } from "./faq";
import { AidDemoVideoSection } from "./aid-demo-video-section";

type AidTemplateProps = {
  /** The product page uses the demo video in the hero whereas ads have a custom hero, and the demo video in the template.  */
  isAdsPage?: boolean;
  customers: Customer[];
};

export function AidTemplate({ isAdsPage, customers }: AidTemplateProps) {
  const whoop = getSafeCustomer(customers, "whoop");

  return (
    <Box>
      {isAdsPage && (
        <AidDemoVideoSection
          title="An AI platform that drives real results"
          textMaxW="100%"
          my={0}
          mt={sectionSpacingY}
          pb={sectionSpacingY}
        />
      )}
      <SolidPlate
        id="ai-agents"
        bgColor="new.violet.950"
        theme="dark"
        spotlightColor="new.violet.900"
        maxW="100%"
        py={{ base: "bigger", md: "biggest" }}
        px={0}
      >
        <FeatureAccordion />
        <AuraPlate condensed theme="dark" variant="violet" my="biggest">
          <CenteredQuote
            theme="dark"
            maxW="800px"
            quoteText="With AI Decisioning, we saw a significant lift in our cross-sell campaigns within just 6 weeks. It’s transformed our team’s focus from manual tasks to high-impact strategic work"
            author={{ name: "Aoife O’Driscoll", job: "AVP Lifecycle Marketing" }}
            company={{ name: "Whoop", logo: whoop.logoUrl }}
          />
        </AuraPlate>
        <SetUpSlideshow />
      </SolidPlate>
      <UseCaseGrid />
      <Faq />
    </Box>
  );
}
